import React from "react";
import ReactDOM from "react-dom";
import LCAppBar from "./pages/appBar";
import * as serviceWorker from "./serviceWorker";
import localizationManager from "./pages/localizationManager";
import { slugToLang } from "./utils/langUrl";

const rootElement = document.getElementById("navbar");
const isPrerendered =
    rootElement.getAttribute("data-prerendered") === "true";

if (navigator.userAgent === "ReactSnap") {
    window.snapSaveState = () => {
        rootElement.setAttribute("data-prerendered", "true");
    };
}

(async () => {
    const savedLang = localStorage.getItem("userLang");
    const routeLang = slugToLang(window.location.pathname.split("/")[1]);
    await localizationManager.setupLocalization(routeLang || savedLang);

    if (isPrerendered) {
        const prerenderedStyles = document.querySelectorAll("style[data-jss]");
        for (let i = 0; i < prerenderedStyles.length; i += 1) {
            prerenderedStyles[i].parentNode.removeChild(prerenderedStyles[i]);
        }
        rootElement.innerHTML = "";
    }

    ReactDOM.render(<LCAppBar />, rootElement);
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
